<template>
  <div class="message" :class="{ '-local': isLocalMessage }">
    <span class="text" v-html="parsedMessage"></span>
    <span class="received" :title="message.created_at">{{ fancyTime }}</span>
  </div>
</template>

<script>
import { marked } from "marked";
import moment from "moment";
import emoji from "node-emoji";

export default {
  name: "Message",

  props: {
    message: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      now: new Date().getTime()
    };
  },

  computed: {
    fancyTime() {
      return moment(this.message.created_at, "YYYY-MM-DD HH:mm:ss").from(this.now);
    },

    isLocalMessage() {
      return !this.message.customer_id;
    },

    isBotMessage() {
      return this.isLocalMessage && !this.message.user_id;
    },

    parsedMessage() {
      let msg = this.message.content;

      // Prepend Bot name
      if (this.isBotMessage) msg = "**Bot:** " + msg;

      // Markdown
      return marked(msg, { sanitize: true }, (err, str) => {
        if (err) console.error("Error parsing message:", err);

        // line breaks
        str = str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1" + "<br>" + "$2").trim();

        // don't let message end in a break
        if (str.substr(str.length - 4, str.length) === "<br>") {
          str = str.slice(0, -4);
        }

        // Open links in new tabs
        str = str.replace(/<a /gi, "<a target='_blank' ");

        // Emoji
        str = emoji.emojify(
          str,
          (name) => {
            return ":" + name + ":";
          },
          (code, name) => {
            return '<span class="emoji">' + code + "</span>";
          }
        );

        return str.trim();
      });
    }
  },

  created() {
    setInterval(() => {
      this.now = new Date().getTime();
    }, 10000);
  }
};
</script>
